import { render, staticRenderFns } from "./ProductGroupNewButton.vue?vue&type=template&id=b08387ac&scoped=true&"
import script from "./ProductGroupNewButton.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroupNewButton.vue?vue&type=style&index=0&id=b08387ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08387ac",
  null
  
)

export default component.exports